import { render } from "./EditorWidget.vue?vue&type=template&id=5dc61304"
import script from "./EditorWidget.vue?vue&type=script&lang=js"
export * from "./EditorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__